import { DateInputValue } from "basis";
import { OptionsValues } from "components/types";
import { ActionMap } from "library/ActionMap";
import { AccountInfo } from "library/hooks/types";
import { stateOptions } from "library/sharedOptions";
import { MakeRequired } from "library/utils";
import { typeOfDisputeOptions } from "./options";

export enum PAGES {
  FORM,
  SUCCESS,
}

export enum ActionType {
  FORM_SUBMITTED = "FORM_SUBMITTED",
  ACCOUNT_INFO_LOADED = "ACCOUNT_INFO_LOADED",
}

type StateTypes = OptionsValues<typeof stateOptions>;
type TypeOfDisputeOptionsType = OptionsValues<typeof typeOfDisputeOptions>;

type Transaction = {
  date: DateInputValue;
  amount: string;
  merchant: string;
};

export type FormValues = {
  firstName: string;
  lastName: string;
  dateOfBirth: DateInputValue;
  address: string;
  suburb: string;
  state: StateTypes;
  postCode: string;
  mobileNumber: string;
  typeOfDispute: TypeOfDisputeOptionsType;
  description: string;
  transactions: { [id: string]: Transaction };
};

export type State = {
  page: PAGES;
  accountInfo?: AccountInfo;
};

export type Payloads = {
  [ActionType.FORM_SUBMITTED]: {};
  [ActionType.ACCOUNT_INFO_LOADED]: {
    accountInfo: AccountInfo;
  };
};

export type Action = ActionMap<ActionType, Payloads>;

export type ScreenComponentType = React.FC<ScreenProps>;
export type PageInfo = {
  [key: string]: {
    heading: string;
    screenComponent: ScreenComponentType;
  };
};

export type ApiGetResponse = {};

export type GetTransactionDisputeParams = FormValues & {
  isNZ: boolean;
  userName: string;
  token: string;
  email: string;
  last4Digits: string;
};

export type ScreenState = MakeRequired<State, "accountInfo">;

export type ScreenProps = {
  state: ScreenState;
  dispatch: React.Dispatch<Action>;
};
